<template>
    <div>
        <Modal ref="modal-login" id="modal-login" v-if="showModal" @close="hide()">
            <div slot="body" class="d-block">
                <div class="container">
                    <div class="row">
                        <div class="col-10">
                            <p class="modal-title mt-3 mb-3">
                                {{ (showLogin ? 'Inicia sesión' : 'Registro') }}
                            </p>
                            <p v-if="showLogin" class="modal-description-text">
                                Ingresa tu cuenta de correo electrónico con la que te registraste y te enviaremos un mail con tu acceso.
                            </p>
                            <p v-else class="modal-description-text">
                                Ingresa tu información para completar tu registro.
                            </p>
                        </div>
                        <div class="col-2 text-right">
                            <img v-img-prefix @click="hide()" class="img-close float-right mt-3 mb-3"
                                 :src="`/public-assets/close-modal`" alt="close-modal">
                        </div>
                    </div>
                    <div class="row" v-if="showLogin">
                        <div class="col-12 mt-2 mb-2 text-center" v-if="showMeesageConfirm != null">
                            <label class="validation">
                                {{ showMeesageConfirm }}
                            </label>
                        </div>
                        <div class="col-12 col-md-12">
                            <input v-model="userCredentials.email" @blur="validateFormat('email', 'email')" type="email" class="form-control" placeholder="Correo Electrónico">
                            <label class="validation" v-show="errors['email']">{{errors['email']}}</label>
                        </div>
                        <div class="col-12 col-md-12 text-right">
                            <button v-if="!isLoading" @click="login()" class="btn-custom mt-4 w-30">Enviar Acceso</button><br>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-center" v-if="isLoading && showLogin">
                            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                        <div class="border-top mt-4 mb-4 w-100"></div>
                    <div class="row" v-if="!showLogin">
                        <div class="col-6">
                            <input v-model="userCredentials.firstName" type="text" class="form-control" placeholder="Nombre">
                            <label class="validation" v-show="errors['firstName']">{{errors['firstName']}}</label>
                        </div>
                        <div class="col-6">
                            <input v-model="userCredentials.lastName" type="text" class="form-control" placeholder="Apellido">
                            <label class="validation" v-show="errors['lastName']">{{errors['lastName']}}</label>
                        </div>
                        <div class="col-12 text-center">
                            <p class="login-chooice mt-4 mb-4">Ingresa tu correo electrónico y numero de teléfono</p>
                        </div>
                         <div class="col-6">
                            <input @click="methodLogin('mail')" :readonly="!isWithMail" v-model="userCredentials.email" @blur="validateFormat('email', 'email')" type="email" class="form-control" placeholder="Correo Electronico">
                            <label class="validation" v-show="errors['email']">{{errors['email']}}</label>
                        </div>
                        <div class="col-6">
                            <input type="phone" autocomplete="off" v-mask="'(###)-###-####'" @input="checkClientPhoneNumber()" v-model="userCredentials['phone']['number']" placeholder="Teléfono Celular" class="form-control" id="phone">
                            <label class="validation" v-show="errors['phone']">{{errors['phone']}}</label>
                        </div>
                        <div class="col-12">
                            <p class="terms-text mt-3">
                                <input v-model="terms" class="check-terms" type="checkbox" aria-label="Checkbox for following text input">
                                <span class="ml-3">Acepto </span><span class="conditions-text">terminos y condiciones</span>
                                <br v-show="errors['terms']">
                                <label class="validation" v-show="errors['terms']">{{errors['terms']}}</label>
                            </p>
                        </div>
                        <div class="col-12 mb-5">
                            <div class="row">
                                <div class="col-12 text-center" v-if="isLoading">
                                    <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                                <div class="col-6"></div>
                                <div class="col-6" v-if="!isLoading">
                                    <button @click="register()" class="ml-md-5 btn-custom mt-4 float-right w-50">Enviar Acceso</button>
                                </div>
                                <div class="col-12 text-center">
                                    <label class="validation" v-show="serverError">{{serverError}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-center">
                            <p class="modal-footer-text" @click="showLogin = !showLogin" v-if="showLogin">Si aún no esta registrado <span class="modal-anchor-text">haz click aquí</span></p>
                            <p class="modal-footer-text" @click="showLogin = !showLogin" v-else>Si ya estas registrado <span class="modal-anchor-text">haz click aquí</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import Modal from './Modal.vue';

export default {
    components: { Modal },
    data(){
        return{
            showMeesageConfirm: null,
            VerifyInputs:['firstName','lastName','email','terms', 'phone'],
            VerifyInputsLogin:['email'],
            userCredentialsLogin:{
                data:{
                    email: null,
                    password: null
                }
            },
            userCredentials:{
                firstName: null,
                lastName: null,
                phone: {
                    "country": "MX",
                    "number": null,
                    "countryCode": "+52",
                    "fullNumber": null
                },
                email: null,
                password: null,
                confirmPassword: null,
            },
            existsPhoneNumber: false,
            terms: false,
            showLogin: true,
            isLoading: false,
            serverError: null,
            isWithMail: true,
            status: {
                isChecking: false,
                isCheckingPhone: false
            },
            errors: {},
            showModal: false
        }
    },
    watch:{
        showLogin: function( newValue ){
            this.userCredentials.firstName = null;
            this.userCredentials.lastName = null;
            this.userCredentials.email = null;
            this.userCredentials.password = null;
            this.userCredentials.confirmPassword = null;
            this.terms = false;
            this.errors = {};
        }
    },
    methods:{
        show() {
            this.showModal = true;
        },
        hide() {
            this.showModal = false;
        },
        register(){
            // Verify all inputs
            this.VerifyInputs.forEach(input => {
                this.validateSimple( input );
            });
            this.validateFormat('email','email');
            if( this.userCredentials.password == this.userCredentials.confirmPassword ){
                this.userCredentials['phone']['fullNumber'] = this.userCredentials['phone']['countryCode'].concat(this.userCredentials['phone']['number'].replaceAll("-", "").replaceAll("(", "").replaceAll(")", ""));
                delete this.errors['differentsPassword'];
                // If doesn't exist errors try to register
                if( Object.entries(this.errors).length === 0 && this.errors.constructor === Object ){
                    this.requestRegister();
                }
            }else{
                this.errors['differentsPassword'] = 'Los campos de contraseña son distintos';
                this.errors = JSON.parse(JSON.stringify(this.errors));
            }
        },
        login(){
            // Verify all inputs
            this.VerifyInputsLogin.forEach(input => {
                this.validateSimple( input );
            });
            this.validateFormat('email','email');
            if( Object.entries(this.errors).length === 0 && this.errors.constructor === Object ){
                this.requestLogin();
            }
        },
        validateFormat(inputName, format){
            let regex = null;
            switch(format){
                case 'email':
                    regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                break;
                case 'number':
                    regex = /^-?\d+\.?\d*$/;
                break;

            }
            delete this.errors[inputName];
            // Restore reactivity on object
            this.errors = Object.assign({}, this.errors);
            if(!this.userCredentials[inputName]){
                this.errors[inputName] = 'Este campo es requerido';
                this.errors = JSON.parse(JSON.stringify(this.errors));
            }else{
                if( regex && !regex.test(String(this.userCredentials[inputName]).toLowerCase()) ){
                    this.errors[inputName] = 'El formato no es valido';
                    this.errors = JSON.parse(JSON.stringify(this.errors));
                }
            }
        },
        validateSimple(inputName){
            this.serverError = null;
            delete this.errors[inputName];
            // Restore reactivity on object
            this.errors = Object.assign({}, this.errors);
            if(!this.userCredentials[inputName]){
                // Custom message to condition terms
                if(inputName == 'terms'){
                    if(this.terms == false){
                        this.errors[inputName] = 'Por favor, acepte términos y condiciones para continuar';
                        this.errors = JSON.parse(JSON.stringify(this.errors));
                    }
                }else{
                    // For all inputs
                    this.errors[inputName] = 'Este campo es requerido';
                    this.errors = JSON.parse(JSON.stringify(this.errors));
                }
            }else{
                if(inputName == 'phone'){
                    if(this.userCredentials[inputName]['number'] && this.userCredentials[inputName]['number'].length < 14){
                        this.errors[inputName] = 'Por favor ingrese los 10 dígitos de su número de telefónico';
                    }
                    if(!this.userCredentials[inputName]['number']){
                        this.errors[inputName] = 'Este campo es requerido';
                    }
                    this.errors = JSON.parse(JSON.stringify(this.errors));
                }
                if(inputName == 'terms'){
                    if(this.terms == false){
                        this.errors[inputName] = 'Por favor, acepte términos y condiciones para continuar';
                        this.errors = JSON.parse(JSON.stringify(this.errors));
                    }
                }
            }
        },
        requestRegister(){
            this.isLoading = true;
            this.$axios.post('/api/v1/contacts/register',{
                data: {
                    given_name: this.userCredentials.firstName,
                    last_name: this.userCredentials.lastName,
                    email: this.userCredentials.email,
                    phone: {
                        "country": "MX",
                        "number": this.userCredentials.phone.number.replaceAll("-","").replaceAll("(","").replaceAll(")",""),
                        "countryCode": "+52",
                        "fullNumber": this.userCredentials.phone.fullNumber
                    },
                    'is_email_verified': true,
                }
          }).then((response)=>{
              // set cookie mints_user_session_token to redirect a settings page with session started
                document.cookie = `mints_contact_session_token=${response.data.session_token};path=/;`;
                // Set contact id token cookie
                document.cookie = `mints_contact_id=${response.data.contact.id_token};path=/;`;
                // Set other cookie with contact data
                document.cookie = `mints_contact_data=${response.data.contact.given_name};path=/;`;
                document.cookie = `mints_contact_email=${response.data.contact.email};path=/;`;
                // Redirect to settings page
                this.resetData();
                this.showLogin = true;
                this.$emit("afterLogin", response.data.contact);
                this.$bus.$emit('register',response.data.contact);
                this.hide();
                let alert = this.$alerts['login-register-success'].content.values
                this.$awn.success(alert.description.value,{labels: {success: alert.title.value}});
              this.isLoading = false;
          }).catch( err =>{
              console.error( err );
              this.serverError = "Ocurrió un error, Este correo ya ha sido regístrado";
              this.isLoading = false;
          });
        },
        requestLogin(){
            // Check validation for email field again
            this.validateFormat('email', 'email');
            // Check that doesn't exists errors with email field
            if(Object.entries(this.errors).length === 0 && this.errors.constructor === Object){
                // Normalize user email before send
                this.userCredentials.email = this.userCredentials.email.trim().toLowerCase();
                //  Set loading status to true
                this.isLoading = true;
                // Send magic link
                this.sendUserMagicLink(window.location.pathname);
            }else{
                this.$awn.warning('El email no tiene formato correcto',{labels: {warning: "Atención"}});
            }
        },
        sendUserMagicLink(UrlToRedirect) {
            let uri = window.location.search.substring(1);
            let params = new URLSearchParams(uri);
            if(params.get('login')){
                UrlToRedirect = '/contactos/perfil?r=appointments'
            }
            let data = {
                email: this.userCredentials.email,
                redirect: UrlToRedirect,
                template: 'site-contact-magic-link'
            }
            this.$axios.post('/api/send-magic-link', data).then((response)=>{
                if(response['data']['success'] && response['data']['total_sent'] > 0){
                    let alert = this.$alerts['login-send-magic-link'].content.values
                    this.$awn.success(alert.description.value.replace('mailVar', this.userCredentials.email),{labels: {success: alert.title.value}});
                    this.sendEmail = false;
                    this.hide();
                    this.resetData();
                }else{
                    let alert = this.$alerts['login-mail-not-found'].content.values
                   this.$awn.warning(alert.description.value, {labels: {warning: alert.title.value}});
                   this.showLogin = false;
                }
            }).catch(e => {
                console.error(e);
                this.userCredentials.email = null;
            }).finally(() => {
                // Reset email input 
                this.isLoading = false;
            })
        },
        methodLogin( type ){
            this.isWithMail = ( type == 'mail' ? true : false );
            if( this.isWithMail ){
                //Login memthod with email
            }else{
                //Login memthod with phone
            }
        },
        sendMagicLink(userEmail, UrlToRedirect) {
            let data = {
                lifeTime: 999999,
                email: userEmail,
                redirectUrl: UrlToRedirect,
            }
            this.$axios.post('/api/v1/contacts/magic-link', {data: data})
            .then((r)=>{
                this.showMeesageConfirm = `Se envió un correo de verificación a ${userEmail}`;
            })
            .catch(error => {
                console.error({error: error})
            }).finally(() => {

            });
        },
        resetData(){
            this.userCredentialsLogin.data.email = null;
            this.userCredentialsLogin.data.password = null;
            this.userCredentials.firstName = null;
            this.userCredentials.lastName = null;
            this.userCredentials.email = null;
            this.userCredentials.password = null;
            this.userCredentials.confirmPassword = null;
            this.terms = false;
            this.showMeesageConfirm = null;
            this.userCredentials.phone = {
                "country": "MX",
                "number": null,
                "countryCode": "+52",
                "fullNumber": null
            }
            this.errors = {};
        },
        checkClientPhoneNumber() {
            if(this.userCredentials['phone']['number'].length == 14 && !this.status['isCheckingPhone']) {
                this.status['isCheckingPhone'] = true;
                let data = {
                    phone: '+52' + this.userCredentials['phone']['number'].replaceAll("-", "").replaceAll("(", "").replaceAll(")", "")
                }
                // Update product
                this.$axios.post('/app/check_client_phone', data)
                .then(response => {
                    if(response['data']['data'].length > 0){
                        // Display error
                        this.errors['phone'] = 'Este número telefónico ya ha sido registrado anteriormente'
                        // Restore reactivity on object
                        this.errors = Object.assign({}, this.errors);
                        this.existsPhoneNumber = true;
                        this.$awn.warning('Este número telefónico ya ha sido registrado anteriormente, por favor ingrese uno nuevo..',{labels: {success: "Número telefónico registrado"}});
                    }else{
                        // Delete property of errors if exists
                        delete this.errors['phone'];
                        // Restore reactivity on object
                        this.errors = Object.assign({}, this.errors);
                        this.existsPhoneNumber = false;
                    }
                }).catch(error => {
                    console.error(error)
                }).finally(() => {
                    this.status['isCheckingPhone'] = false;
                });
            }else{
                this.validateSimple('phone');
            }
        }
    },
}
</script>

<style lang="scss" scoped>
    @import 'vue-awesome-notifications/dist/styles/style.css';
    .modal-description-text{
        color: grey;
    }
    .modal-footer-text{
        color: grey;
    }
    .modal-anchor-text {
        cursor: pointer;
        color: #133C92;
        font-weight: 600;
        text-decoration: underline;
    }
</style>